import React, { useEffect } from 'react';
import classNames from 'classnames';
import tracker from '../service/tracker';
import { ListingsPerseusPropTypes } from '../types';
import { FLOWS } from '../utils/constants';
import Store from '../store';
import { AppError, ErrorBoundary } from './common';
import { SubCategories, BusinessSubCategories } from './subcategories';
import { Search, BusinessSearch } from './search';
import { ProSubCategories } from './pro_subcategories/ProSubCategories';
import './index.scss';

const ListingsComponentMapper = {
    [FLOWS.CATEGORY]: SubCategories,
    [FLOWS.SEARCH]: Search,
    [FLOWS.BUSINESS_SEARCH]: BusinessSearch,
    [FLOWS.PRO_CATEGORY]: ProSubCategories,
    [FLOWS.BUSINESS_CATEGORIES]: BusinessSubCategories
};

const ListingsPerseus = ({ displayData, topBarSorting, appData, knownCrawler, listings, requestContext }) => {
    useEffect(() => {
        tracker.view();
    }, []);

    const { filter, pagination, sorting, user: { loggedIn, userCountry }, flow, abTests, baseUrl } = appData;
    const Component = ListingsComponentMapper[flow];
    const listingsPerseusClassNames = classNames('listings-perseus');

    return (
        <div className={listingsPerseusClassNames}>
            <Store knownCrawler={knownCrawler} listings={listings} appData={appData} requestContext={requestContext}>
                <ErrorBoundary fallback={AppError}>
                    <Component loggedIn={loggedIn}
                        userCountry={userCountry}
                        sorting={sorting}
                        displayData={displayData}
                        appFilters={filter}
                        topBarSorting={topBarSorting.map((opt) => ({ ...opt, selected: opt.id === sorting.sortBy }))}
                        pagination={pagination}
                        abTests={abTests}
                        baseUrl={baseUrl}/>
                </ErrorBoundary>
            </Store>
        </div>
    );
};

ListingsPerseus.propTypes = ListingsPerseusPropTypes;

export default ListingsPerseus;
